import { default as BSOffcanvas } from 'bootstrap/js/src/offcanvas'

class Offcanvas extends BSOffcanvas {}

export default Offcanvas
